module.exports = __webpack_public_path__ + "media/images/emblems/Gonten-Wappen-58e6d73eeb362778e91a7ecea10480f9.png";